// INDEX
export const ROOT = '';
export const INDEX = '/';
export const SUCCESS = '/success';
export const NOT_FOUND = '/404';
export const OFFER_T2 = '/docs/Оферта Т2.pdf'
export const OFFER_RNKO = '/docs/Оферта РНКО.pdf'
export const OFFER_ITK = '/docs/Оферта ППМ ООО ИТ Консул.pdf'
export const OFFER_POLICY = '/docs/Политика ПД.pdf'